import { render, staticRenderFns } from "./LotTemplateInfoView.vue?vue&type=template&id=86c64bc6&"
import script from "./LotTemplateInfoView.vue?vue&type=script&lang=js&"
export * from "./LotTemplateInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports